import { Button } from 'src/components/ui/button';
import { ChevronDown, ChevronsDown, ChevronsUp } from 'lucide-react';

export interface TxIOPaginationProps {
  totalCount: number;
  currentCount: number;
  isLoading: boolean;
  hasMore: boolean;
  canShowLess: boolean;
  loadMore: (showAll: boolean) => void;
  showLess: () => void;
}

export function TxIOPagination({
  totalCount,
  currentCount,
  isLoading,
  hasMore,
  canShowLess,
  loadMore,
  showLess,
}: TxIOPaginationProps) {
  const remainingCount = totalCount - currentCount;
  const showMoreCount = Math.min(25, remainingCount);

  if (!hasMore && !canShowLess) return null;

  return (
    <div className="bg-gray-50">
      <div className="flex flex-wrap items-center gap-2">
        {hasMore && (
          <>
            {remainingCount >= 25 && (
              <Button
                variant="ghost"
                size="sm"
                className="flex h-7 items-center gap-1 text-xs text-gray-600"
                onClick={() => loadMore(false)}
                disabled={isLoading}
              >
                <ChevronDown className="h-3.5 w-3.5" />
                {isLoading ? 'Loading...' : `Show ${showMoreCount} more`}
              </Button>
            )}
            <Button
              variant="ghost"
              size="sm"
              className="flex h-7 items-center gap-1 text-xs text-gray-600"
              onClick={() => loadMore(true)}
              disabled={isLoading}
            >
              <ChevronsDown className="h-3.5 w-3.5" />
              {isLoading
                ? 'Loading...'
                : `Show all ${remainingCount} remaining`}
            </Button>
          </>
        )}

        {canShowLess && (
          <Button
            variant="ghost"
            size="sm"
            className="ml-auto flex h-7 items-center gap-1 text-xs text-gray-600"
            onClick={showLess}
          >
            <ChevronsUp className="h-3.5 w-3.5" />
            Collapse
          </Button>
        )}

        <div className="ml-auto text-xs text-gray-500">
          Showing {currentCount} of {totalCount}
        </div>
      </div>
    </div>
  );
}
